import modelExtend from 'dva-model-extend'
import { basicModel, UPDATESTATE } from '@sisyphe/utils'
import * as api from 'services/store'

export default modelExtend(basicModel, {
  namespace: 'search',
  state: {
    list: [],
    total: 0,
    pageSize: 20,
  },
  reducers: {},
  effects: {
    /** 商城搜索框搜索 */
    *searchUsingPOST({ payload: { searchType, ...payload } }, { call, put }) {
      // 点击类目时调用的时APP的接口
      let apiServe
      payload = { ...payload }
      if (searchType === 'search') {
        apiServe = api.searchUsingPOST
        delete payload.frontCategoryCodes
      } else {
        apiServe = api.morePageQueryUsingPOST
        delete payload.frontCategoryCode
        delete payload.keyWord
      }
      const { data } = yield call(apiServe, payload)
      yield put({
        type: UPDATESTATE,
        payload: {
          list: data?.mainInfos || data?.records,
          total: data?.total || 0,
        },
      })
      return data
    },
  },
})
